import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
/**
 * Wizard step label component
 * This component should be using in correlation to the `aw-wizard` https://www.npmjs.com/package/angular-archwizard
 * to create the step icons (circle check if completed, cicle step number otherwise )
 *
 * @param currentIndex {number} Current step  Default is set to 1
 * @param stepIndex {number} Index of step
 * @param stepTitle {string}
 * @param stepIsValid {boolean} Default is set to false
 * @param size {string "large" | "medium"} Default is set to large
 *
 * @example
 * ```
 * <dgx-aw-wizard-step-label [orgId]="orgId"
 *    [currentIndex]="1"
 *    [stepIndex]="2"
 *    [stepIsValid]="false"
 *    [stepTitle]="'titleTotranslate' | translate"
 *    size="medium" >
 * </dgx-aw-wizard-step-label>
 * ```
 */
@Component({
  selector: 'dgx-aw-wizard-step-label',
  templateUrl: './wizard-step-label.component.html',
  styleUrls: ['./wizard-step-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardStepLabelComponent {
  @Input() public currentIndex = 1;
  @Input() public stepIsValid = false;
  @Input() public stepIndex = 1;
  @Input() public stepTitle: string;
  @Input() public size: 'large' | 'medium' = 'large';

  public get isCurrentStep(): boolean {
    return this.stepIndex === this.currentIndex;
  }
}
